import Typography from '@mui/material/Typography'
import ButtonBase from '@mui/material/ButtonBase'
import EmailOutlined from '@mui/icons-material/EmailOutlined'
import { styled } from '@mui/styles'

export const Root = styled(ButtonBase)({
  maxHeight: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  minWidth: 'fit-content',
  paddingRight: 8,
  paddingLeft: 8,
})

export const ButtonText = styled(Typography)(({ theme }) => ({
  paddingTop: 0,
  fontSize: 10,
  [theme.breakpoints.down('md')]: {
    paddingTop: 0,
    fontSize: 10,
  },
}))

export const EmailBrochureIcon = styled(EmailOutlined)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: '36px',
  width: '36px',
}))
